import { Switch, Route, HashRouter } from 'react-router-dom';

import React, { useEffect } from 'react';
import config from 'config';
import NotFound from 'NOTICEBOARD/CommonResources/NotFound/NotFound';
import NoticeBoard from 'NOTICEBOARD/Components/NoticeBoard'
import ManageNotice from 'NOTICEBOARD/Components/ManageNotice'
import ManageCategory from 'NOTICEBOARD/Components/ManageCategory';
import StudentNoticeDashboard from 'NOTICEBOARD/Components/StudentNoticeDashboard/StudentNoticeDashboard';
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import Reports from 'NOTICEBOARD/Components/Reports/Reports'; 
import StartUpScreen from 'NOTICEBOARD/CommonResources/StartUpScreen/StartUpScreen';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getNoticeAccessDetails } from 'NOTICEBOARD/Actions/RoutingActions';
import SwitchNoticePage from 'NOTICEBOARD/Components/SwitchNoticepage';

const RoutesSetup = () => {
    //GET TEMPLATE DATA
    const routingMenu = useSelector((state) => state.RouteMenuReducer);

    const dispatch = useDispatch();

    useEffect(() => {
        if(config.account == 'faculty') {
            if(Object.keys(routingMenu.accessDetails).length == 0) {
                dispatch(getNoticeAccessDetails());
            }
        }
    }, []);

    return (
        <>
            <HashRouter>
                {
                    config.account == 'faculty' ?
                        <>
                            {
                                routingMenu.isAdminFetching ?
                                    <Spinner />
                                :
                                    <Switch>
                                        <Route exact path="/" component={StartUpScreen} />
                                        <Route path="/noticeboard" component={NoticeBoard} />
                                        {
                                            routingMenu.isNoticeAdmin &&
                                                <Route path="/postnotice" component={SwitchNoticePage} />
                                        }
                                        {
                                            routingMenu.isCategoryAdmin &&
                                                <>
                                                    <Route path="/grantaccess" component={ManageCategory} />
                                                    <Route path="/reports/:id" component={Reports} />                                                
                                                </>
                                        }
                                        <Route path="*" component={NotFound} />
                                    </Switch>
                            }
                        </>
                    :
                            <Switch>
                                <Route exact path="/" component={StudentNoticeDashboard} />
                                <Route path="*" component={NotFound} />
                            </Switch>
                }
            </HashRouter>
        </>
    );
}

export default RoutesSetup;
